import React from 'react';
import ComingSoon from '../../components/common/ComingSoon';

const icon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;

const Regulations = () => (
  <ComingSoon
    title="Mevzuat"
    description="Elektrik, mekanik ve yapı mevzuatlarını takip edebileceğiniz, güncel yönetmeliklere ulaşabileceğiniz mevzuat arşivi yakında burada."
    icon={icon}
    activeId="feed_regulation"
  />
);

export default Regulations;
